import React, { ComponentProps, ReactNode } from 'react';
import { ButtonContainer } from './ReturnButton.styles';
import { PortalLink } from '../PortalButton';
import { t } from 'i18next';

interface IReturnButton {
  linkProps: ComponentProps<typeof PortalLink>;
  children?: ReactNode;
}

const ReturnButton = ({
  linkProps: { colorType = 'secondary', ...rest },
  children,
}: IReturnButton) => {
  return (
    <ButtonContainer>
      <PortalLink colorType={colorType} {...rest}>
        {children || t('ReturnToAgreements')}
      </PortalLink>
    </ButtonContainer>
  );
};

export default ReturnButton;
